const src = require("/app/src/assets/images/svg/arrow-right.svg?as-resource");
const img = new String(src);
img.src = src;
img.width = 14;
img.height = 13;
img.toString = function() { return src; };
module.exports = img;